export default "__VITE_ASSET__$qMzPqfV__"